import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { truncateTooltip } from "./tooltip.js";
import Tooltip from "../Tooltip/Tooltip.js";
const TextWrapper = styled(Box)(({
  theme
}) => ({
  minWidth: "7rem",
  display: "grid",
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: theme.sizes.spacing.none
}));
const Text = styled(Typography)(({
  theme
}) => ({
  color: theme.colors.text.primary,
  fontSize: theme.fonts.size.sm,
  fontFamily: theme.fonts.family.body,
  fontWeight: theme.fonts.weight.normal,
  lineHeight: theme.fonts.lineHeight["leading-5"],
  letterSpacing: theme.fonts.letterSpacing.wide
}));
const CellText = (t0) => {
  const $ = c(7);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = truncateTooltip(text);
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = /* @__PURE__ */ jsx(Text, { noWrap: true, variant: "valueCell", children: text });
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = /* @__PURE__ */ jsx(TextWrapper, { children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", title: t1, children: t2 }) });
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export {
  CellText as default
};
